import React, {useMemo} from 'react';
import ReactECharts from 'echarts-for-react';
import {ChatChartSpec, buildChartOption} from './chartUtils';
import {ChartCardWrap, ChartCardTitle, ChartCardDescription, ChartHost} from './ChatMessageItem.style';

interface ChartCardProps {
  chart: ChatChartSpec;
}

export const ChartCard: React.FC<ChartCardProps> = ({chart}) => {
  const option = useMemo(() => buildChartOption(chart), [chart]);

  if (!chart || !Array.isArray(chart.data) || chart.data.length === 0) return null;

  return (
    <ChartCardWrap>
      {chart.title && <ChartCardTitle>{chart.title}</ChartCardTitle>}
      {chart.description && <ChartCardDescription>{chart.description}</ChartCardDescription>}
      <ChartHost>
        <ReactECharts
          option={option}
          style={{height: 280, width: '100%'}}
          opts={{renderer: 'canvas'}}
        />
      </ChartHost>
    </ChartCardWrap>
  );
};

export default ChartCard;
